module.exports = __webpack_public_path__ + "static/img/6.4237714.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/7/2/eng/6.png
// module id = qBxP
// module chunks = 0